import React from "react";
const HeaderSlider = ({ props }) => {
  return (
    <div className="home_slider_container">
      <div className="owl-carousel owl-theme home_slider">
        {Object.keys(props.homePage.sliderElements).map((key,index) => {
        return<div key={index} className="owl-item">
            <div
              className="background_image"
              style={{
                backgroundImage:`url(${'/Assets/images/box_3.jpg'})` 
              }}
            ></div>
            <div className="container fill_height">
              <div className="row fill_height">
                <div className="col fill_height">
                  <div className="home_container d-flex flex-column align-items-center justify-content-start">
                    <div className="home_content">
                      <div className="home_title">
                        {props.homePage.sliderElements[key].sentences[0]}
                      </div>
                      <div className="home_subtitle">
                        {props.homePage.sliderElements[key].sentences[1]}
                      </div>
                      <div className="home_items">
                        <div className="row">
                          <div className="col-sm-3 offset-lg-1">
                            <div className="home_item_side">
                                <img
                                  src={
                                    props.homePage.sliderElements[key].images[1]
                                  }
                                  alt=""
                                />
=                            </div>
                          </div>
                          <div className="col-lg-4 col-md-6 col-sm-8 offset-sm-2 offset-md-0">
                            <div className="product home_item_large">
                              <div className="product_tag d-flex flex-column align-items-center justify-content-center">
                                <div>
                                  <div>from</div>
                                  <div>
                                    EGP<span>{props.homePage.sliderElements[key].price}</span>
                                  </div>
                                </div>
                              </div>
                              <div  className="product_image">
                                <img
                                
                                  src={
                                    props.homePage.sliderElements[key].images[2]
                                  }
                                  alt=""
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="home_item_side">
                                <img src={props.homePage.sliderElements[key].images[3]} alt="" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>;
        })}
      </div>
      <div className="home_slider_nav home_slider_nav_prev"><i className="fa fa-chevron-left" aria-hidden="true"></i></div>
	<div className="home_slider_nav home_slider_nav_next"><i className="fa fa-chevron-right" aria-hidden="true"></i></div>

    </div>
    
  );
};

export default HeaderSlider;
